import React from "react";

const QuestionDual = ({ title, answers, name, state, setState }) => {
  return (
    <div className="question-num">
      <p className="question-title">{title}</p>
      <div className="answer-chk">
        {answers?.map((answer, key) => (
          <label key={key} className="check-container">
            <input
              type="checkbox"
              name={name}
              value={key + 1}
              onChange={() => {
                if (state.size <= 2 && state.has(key + 1)) {
                  // ([...state]).remove(key + 1);
                  setState(() => {
                    const nextState = new Set([...state]);
                    nextState.delete(key + 1);
                    return nextState;
                  });
                } else if (state.size < 2 && !state.has(key + 1)) {
                  setState(new Set([...state, key + 1]));
                } else if (state.size >= 2) {
                  alert("2개까지만 선택 할 수 있습니다.");
                }
              }}
              checked={state.has(key + 1)}
            />
            <span className="checkmark"></span>
            <span>{answer}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default QuestionDual;
